const ProjectCardData=[
 {
    imgsrc : "https://support.rebrandly.com/hc/article_attachments/360022971393/rebrandly_google_url_shortener_alternative.png",
    title:"Snake Game",
    text:"enjdjjfkkjcjkdjdcjdjddjdcsnsjncsnjccsnjsnjdjnd",
    view:""
  },
  {
    imgsrc : "https://support.rebrandly.com/hc/article_attachments/360022971393/rebrandly_google_url_shortener_alternative.png",
    title:"Snake Game",
    text:"mkjjnjjnlnjnjnjnjnn",
    view:""
  }
];
export default ProjectCardData;